
export const AUTH_TOKEN = '12f6140f-12b9-4294-ae64-e253da259299'
export const GOOGLE_API_KEY = 'AIzaSyARNDXzSr-Heq6c0_4e2LifNMdUlkVLdyY'
export const CUSTOMER_ID = localStorage.getItem('customer_id')